import(/* webpackMode: "eager" */ "/vercel/path0/Website/app/(home)/funding/page.jsx")